import { Money } from "classes/DecimalClasses";

export const ZERO_TOTALS = { amount: Money.ZERO() };

export function updateTotals(lines, setTotals, currencyName) {
  if (!lines || lines.length === 0) {
    setTotals(ZERO_TOTALS);
    return;
  }

  const zeroMoney = Money.ZERO(currencyName);
  const amount = lines.reduce(
    (total, line) => total.plus(line.amount || zeroMoney),
    zeroMoney
  );

  setTotals({ amount });
}
